export const buildCanonical = (
  host: string,  // ex.: parcelacertaimoveis.com.br
  path: string   // ex.: /imoveis/venda/casa/...
) => {
  const cleanPath = path.split('?')[0].split('#')[0];   // sem query e hash
  return `https://${host?.replace(/\/$/, '')}${cleanPath}`; // garante só uma "/"
};